export interface LoginPayload {
  username: string;
  password: string;
  rememberMeDeviceToken?: string | null;
}

export enum SignInServerErrorText {
  CREDENTIALS_ARE_INCORRECT = 'username or password is incorrect',
  USER_ACCOUNT_IS_LOCKED = 'user account is locked',
}

export const SIGN_IN_STEP_PARAM_KEY = 'step';

export enum STEPS {
  SIGN_IN = 'SignIn',
  FORGOT_USERNAME = 'forgotUsername',
  FORGOT_USERNAME_SUCCESS = 'forgotUsernameSuccess',
  FORGOT_PASSWORD = 'forgotPassword',
  NEW_PASSWORD = 'newPassword',
  FORGOT_PASSWORD_SUCCESS = 'forgotPasswordSuccess',
}
